'use strict';

var STORAGE_KEY_PREFIX = 'sensitiveContentFilterUnlockedAt_';
var EXPIRY_MS = 365 * 24 * 60 * 60 * 1000;

function isUnlocked(pid) {
    try {
        var unlockedAt = window.localStorage.getItem(STORAGE_KEY_PREFIX + pid);
        if (!unlockedAt) {
            return false;
        }
        return (Date.now() - parseInt(unlockedAt, 10)) < EXPIRY_MS;
    } catch (e) {
        return false;
    }
}

function persistUnlock(pid) {
    try {
        window.localStorage.setItem(STORAGE_KEY_PREFIX + pid, String(Date.now()));
    } catch (e) {
        // localStorage unavailable (private browsing, quota, etc.) - unlock still applies for this page view only
    }
}

function unlockProduct(pid) {
    $('.sensitive-filter[data-pid="' + pid + '"]').removeClass('is-locked');
}

$(function () {
    $('.sensitive-filter').each(function () {
        var pid = $(this).attr('data-pid');
        if (isUnlocked(pid)) {
            unlockProduct(pid);
        }
    });

    $(document).on('click', '.jsSensitiveFilterReveal', function () {
        $.magnificPopup.open({
            items: {
                src: '#sensitive-filter-modal',
                type: 'inline'
            },
            closeOnBgClick: true,
            mainClass: 'mfp-fade'
        });
    });

    $(document).on('click', '.jsSensitiveFilterAllow', function () {
        var pid = $('.sensitive-filter').attr('data-pid');
        persistUnlock(pid);
        unlockProduct(pid);
        $.magnificPopup.close();
    });

    $(document).on('click', '.jsSensitiveFilterDeny', function () {
        $.magnificPopup.close();
    });
});
